const state = {
	testProp: 'yeah',
};

export default state;



// WEBPACK FOOTER //
// ./scripts/store/state.js